<template>
    <PageTemplateContent>
        <BaseHero
            title="Terms and conditions, privacy and security"
            description="MedPeers is a secure online educational streaming platform intended to teach, coach and upskill medical professionals. MedPeers' primary intent is to improve healthcare education all over the globe."
            data-span-all
        />
        <ContentBlocksText>
            <h2>To ensure a reliable, transparent and impartial dissemination of knowledge & skills, MedPeers…</h2>
        </ContentBlocksText>
        <IconList
            :items="[
                {
                    icon: 'check',
                    description: 'Follows the ICMJE publishing standards'
                },
                {
                    icon: 'check',
                    description: 'Adheres to data protection and privacy legislation in every country'
                },
                {
                    icon: 'check',
                    description: 'Is securely and exclusively accessible  to medical professionals'
                },
                {
                    icon: 'check',
                    description: 'Respects local institutional policies'
                }
            ]"
        />
        <ContentBlocksText>
            <h2>User verification</h2>
            <p>We are actively working to verify that all users on the MedPeers platform are certified medical professionals. This process is essential to establish a secure environment for sharing educational knowledge exclusively with the appropriate individuals while maintaining the highest content quality standards.</p>
            <h2>Our policies</h2>
            <p>
                <BaseButton 
                    :element="defineNuxtLink({})" 
                    to="/legal/icmje"
                    class="base-button--outline"
                    icon-right="arrow-right"
                >
                    ICMJE standards
                </BaseButton>
                <BaseButton 
                    :element="defineNuxtLink({})" 
                    to="/legal/privacy"
                    class="base-button--outline"
                    icon-right="arrow-right"
                >
                    Privacy Policy
                </BaseButton>
                <BaseButton 
                    :element="defineNuxtLink({})" 
                    to="/legal/copyright"
                    class="base-button--outline"
                    icon-right="arrow-right"
                >
                    Copyright and ownership
                </BaseButton>
                <BaseButton 
                    :element="defineNuxtLink({})" 
                    to="/legal/security"
                    class="base-button--outline"
                    icon-right="arrow-right"
                >
                    Security and auditing
                </BaseButton>
            </p>
        </ContentBlocksText>
    </PageTemplateContent>
</template>

<script setup>
const { asset } = useBaseUrl();

useSeoMeta({
    title: 'MedPeers | Legal information',
    description: 'Terms and conditions, privacy and security.',
    ogImage: asset('/images/og/default.png')
});
</script>
